import {translation_hu} from './transaction_hu'
import {translation_en} from './transaction_en'

export const translations = {
    0: translation_hu,
    1: translation_en
};